import { datadogLogs } from '@datadog/browser-logs';
import { useDescope } from '@descope/react-sdk';
import { Button } from '@smithhealth/design-system';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import Logo from '@assets/logo.svg';
import { PortalBanner } from '@components/portal-banner/portal-banner';
import { environmentIndicator } from '@config/services';
import { useSelectedPharmacy } from '@services/pharmacy';
import styles from './layout.module.scss';

export const Layout = ({
  children,
  showNavigation = true,
  wide = false,
}: {
  children: React.ReactNode;
  showNavigation?: boolean;
  wide?: boolean;
}): JSX.Element => {
  const { logout } = useDescope();
  const { clearSelection } = useSelectedPharmacy();

  const onLogoutClick = useCallback(async () => {
    try {
      await logout();
      clearSelection();
      window.location.assign('/');
    } catch (error) {
      datadogLogs.logger.error('Logout failed', {}, error as Error);
    }
  }, [logout, clearSelection]);

  return (
    <div className={styles.layout}>
      <div className={styles.environment} data-testid="environment-indicator">
        {environmentIndicator}
      </div>
      <div className={styles.header}>
        {showNavigation ? (
          <div className={styles.nav}>
            <Link to="/">
              <Logo />
            </Link>
            <Link className={styles.navLink} to="/mac">
              MAC List Lookup
            </Link>
            <Link className={styles.navLink} to="/documents">
              Forms & Documents
            </Link>
          </div>
        ) : (
          <Logo />
        )}
        <Button onClick={onLogoutClick} variant="brand" hierarchy="tertiary">
          Log Out
        </Button>
      </div>
      <div className={`${styles.body} ${wide ? styles.wide : ''}`}>
        {children}
      </div>
      <div className={styles.footer}>
        <span>©2026 SmithRx</span>
        <span>
          For help call <a href="tel:1 (888) 123-4567">1 (888) 123-4567</a>
        </span>
      </div>
      <PortalBanner />
    </div>
  );
};
